import React from 'react';
import Scroll from '../../partials/Scroll/Scroll';
import './Activity.scss';

const Activity = (props) => {
  // const parser = (string) =>{
  //   const paragraphs = string.split('\n');
  //   return paragraphs.map((text, i) => ( <p key={`p-${i}`}>{text}</p> ));
  // }

  return (
    <div className={`activity ${props.className}`}>
        <div className="activity-holder">
            {props.title && <div className="activity-title">
              <h2 
                className='overview' 
                dangerouslySetInnerHTML={{ __html: props.title }} />
            </div>}
            <Scroll>
              <div 
                className="activity-content" 
                dangerouslySetInnerHTML={{ __html: props.content }} />
            </Scroll>
        </div>
    </div>
  );
};

export default Activity; 